import { Grid, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import { CameBackWith } from "./CameBackWoth";
import { Dated } from "./Dated";
import { useSelector } from "react-redux";
import { liquidationStatus } from "helpers/dictionary";

export const UnitCylinderCount = ({ block = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { settlement } = useSelector(({ routesStatus }) => routesStatus);
  // const blockBtn = settlement.settlementStatus === liquidationStatus.value.SAVED || settlement.settlementStatus === liquidationStatus.value.CONFIRMED || settlement.settlementStatus === liquidationStatus.value.READY;
  const blockBtn =
    settlement.settlementStatus !== liquidationStatus.value.ON_HOLD;
  return (
    <>
      {!block && (
        <Grid
          item
          xs={12}
          sm={6}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            color="primary"
            component="h3"
            style={{ marginBottom: 15 }}
          >
            Salio con:
          </Typography>
        </Grid>
      )}
      {!settlement?.unit.type.toLowerCase().includes("estacion") &&
      !isMobile ? (
        <Grid item xs={12} sm={6}>
          <Typography
            variant="body1"
            color="primary"
            component="h3"
            style={{ marginBottom: 15 }}
          >
            Regreso con:
          </Typography>
        </Grid>
      ) : null}
      {!block && (
        <Grid item xs={12} md={6}>
          <Dated block={blockBtn} />
        </Grid>
      )}
      <Grid item xs={12} sm={block ? 12 : isMobile ? 12 : 6}>
        <Grid container spacing={1}>
          <CameBackWith block={block} disabled={blockBtn} />
        </Grid>
      </Grid>
    </>
  );
};
